// @ts-nocheck
// based off of the original buildResponsiveFields.ts file in foundation.  Added the ability to pass in a custom name
// this allows for the ability to have multiple responsive fields on a single content item.  This is useful for when you have multiple tabs that have responsive fields

import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { ChildFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import {
    fieldDefinitionsToDefaultValuesDictionary,
    getValuesPerBreakpoint,
} from "@store/Framework/Features/FieldDefinitionBuilder/fieldDefinitionBuilder";
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";

export const buildResponsiveFields = (
    childFieldDefinitions: ChildFieldDefinition[],
    // Store Custom Code
    responsiveName?: string,
): FoundationFieldDefinition[] => {
    const useResponsiveOptionsField: FoundationFieldDefinition = {
        fieldType: "General",
        // Store Custom Code
        name: responsiveName ? `${responsiveName}ResponsiveOptions` : "useResponsiveOptions",
        displayName: "Use Responsive Options",
        editorTemplate: "CheckboxField",
        defaultValue: false,
    };
    const copyDataToResponsiveField: FoundationFieldDefinition = {
        // Store Custom Code
        name: `${responsiveName || ""}copy`,
        displayName: "Copy Basic Options To Responsive Options",
        editorTemplate: "CopyDataToResponsiveField",
        defaultValue: true,
        fieldType: "General",
        isVisible: item => item.fields[useResponsiveOptionsField.name],
        onClick: handleCopyToResponsive => {
            handleCopyToResponsive(responsiveRows.name, [
                useResponsiveOptionsField.name,
                responsiveRows.name,
                copyDataToResponsiveField.name,
            ]);
        },
    };

    const responsiveRows: FoundationFieldDefinition = {
        // Store Custom Code
        name: responsiveName ?? "responsive",
        editorTemplate: "ListField",
        getDisplay: (item: HasFields) => {
            const firstFieldKey = Object.keys(item.fields)[0];
            return item.fields[firstFieldKey];
        },
        defaultValue: getValuesPerBreakpoint(fieldDefinitionsToDefaultValuesDictionary(childFieldDefinitions)),
        fieldType: "Translatable",
        hideAdd: true,
        hideDelete: true,
        isVisible: item => item.fields[useResponsiveOptionsField.name],
        fieldDefinitions: [...childFieldDefinitions],
    };

    return [useResponsiveOptionsField, copyDataToResponsiveField, responsiveRows];
};
